const getTimeIn = () => {
  const timeNow = new Date().getTime();
  return parseFloat((timeNow + 1) / 1000).toFixed(0);
};

export default getTimeIn;
